/* Amanda's Gifts: estimated delivery steps (Ordered -> Ships -> Delivered) for ShineOn message card jewelry (no app).
   Markup: snippets/ag-delivery-steps.liquid; styles: assets/ag-product.css.
   Facts from the owner: 1-2 business days production + 2-5 business days standard US shipping.
   Shown range = +3 to +8 business days (1 day buffer so we never promise too early).
   All dates are computed in America/New_York; orders after 12:00 ET count from the next business day.
   Business days skip Saturday, Sunday and US federal holidays (observed dates). */
(function (root) {
  var MIN_DAYS = 3, MAX_DAYS = 8, CUTOFF_HOUR = 12, TZ = 'America/New_York';
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  // Calendar days are UTC-midnight Date objects, so day arithmetic never meets DST.
  function day(y, m, d) { return new Date(Date.UTC(y, m, d)); }
  function key(dt) { return dt.toISOString().slice(0, 10); }
  function addDays(dt, n) { return new Date(dt.getTime() + n * 86400000); }
  function nthWeekday(y, m, wd, n) { // n-th weekday wd of month m (n = -1: last)
    if (n > 0) { var f = day(y, m, 1); return addDays(f, ((wd - f.getUTCDay() + 7) % 7) + (n - 1) * 7); }
    var l = day(y, m + 1, 0); return addDays(l, -((l.getUTCDay() - wd + 7) % 7));
  }
  function observed(dt) { var w = dt.getUTCDay(); return w === 6 ? addDays(dt, -1) : w === 0 ? addDays(dt, 1) : dt; }
  var cache = {};
  function holidays(y) {
    if (cache[y]) return cache[y];
    var list = [
      observed(day(y, 0, 1)), nthWeekday(y, 0, 1, 3), nthWeekday(y, 1, 1, 3), nthWeekday(y, 4, 1, -1),
      observed(day(y, 5, 19)), observed(day(y, 6, 4)), nthWeekday(y, 8, 1, 1), nthWeekday(y, 9, 1, 2),
      observed(day(y, 10, 11)), nthWeekday(y, 10, 4, 4), observed(day(y, 11, 25)),
      observed(day(y + 1, 0, 1)) // New Year on a Saturday is observed on Dec 31 of this year
    ];
    var s = {};
    list.forEach(function (d) { s[key(d)] = true; });
    return (cache[y] = s);
  }
  function isBusinessDay(dt) {
    var w = dt.getUTCDay();
    return w !== 0 && w !== 6 && !holidays(dt.getUTCFullYear())[key(dt)];
  }
  function addBusinessDays(dt, n) { while (n > 0) { dt = addDays(dt, 1); if (isBusinessDay(dt)) n--; } return dt; }

  // Wall-clock date/hour in New York for a given instant.
  function nyNow(now) {
    var p = {};
    new Intl.DateTimeFormat('en-US', { timeZone: TZ, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23' })
      .formatToParts(now).forEach(function (x) { p[x.type] = x.value; });
    return { date: day(+p.year, +p.month - 1, +p.day), hour: +p.hour % 24 };
  }

  function estimate(now) {
    var ny = nyNow(now || new Date());
    var start = ny.date;
    if (!isBusinessDay(start) || ny.hour >= CUTOFF_HOUR) { do { start = addDays(start, 1); } while (!isBusinessDay(start)); }
    return { today: ny.date, start: start, from: addBusinessDays(start, MIN_DAYS), to: addBusinessDays(start, MAX_DAYS) };
  }
  function fmt(dt) { return DAYS[dt.getUTCDay()] + ', ' + MON[dt.getUTCMonth()] + ' ' + dt.getUTCDate(); }

  // "December 11" (or "Dec 11") in the current New York year; null when it cannot be read.
  function parseOrderBy(text, year) {
    var m = String(text || '').trim().match(/^([A-Za-z]+)\.?\s+(\d{1,2})/);
    if (!m) return null;
    var name = m[1].toLowerCase();
    for (var i = 0; i < 12; i++) if (MONTHS[i].toLowerCase().indexOf(name) === 0 && name.length >= 3) return day(year, i, +m[2]);
    return null;
  }
  function christmasLine(today, orderByText) {
    var y = today.getUTCFullYear(), by = parseOrderBy(orderByText, y);
    if (!by) return '';
    if (today >= day(y, 10, 15) && today <= by) return 'Order by ' + orderByText.trim() + ' for delivery by Christmas.';
    if (today > by && today <= day(y, 11, 25)) return 'Orders now may arrive after Christmas.';
    return '';
  }

  // Step row: Ordered <today> -> Ships <start+1..+2 bd> -> Delivered <start+3..+8 bd>.
  function md(dt) { return MON[dt.getUTCMonth()] + ' ' + dt.getUTCDate(); }
  function span(a, b, sep) { // "Oct 27–28" in one month, "Oct 30 – Nov 2" across months
    if (key(a) === key(b)) return md(a);
    return a.getUTCMonth() === b.getUTCMonth() ? md(a) + '\u2013' + b.getUTCDate() : md(a) + sep + md(b);
  }
  function steps(now) {
    var e = estimate(now);
    return {
      today: e.today,
      ordered: md(e.today),
      ships: span(addBusinessDays(e.start, 1), addBusinessDays(e.start, 2), '\u2013'),
      delivered: md(e.from) + ' \u2013 ' + md(e.to)
    };
  }
  function renderSteps(el, now) {
    var s = steps(now);
    ['ordered', 'ships', 'delivered'].forEach(function (k) { var d = el.querySelector('[data-ag-step=' + k + ']'); if (d) d.textContent = s[k]; });
    var row = el.querySelector('.ag-dsteps__row'); if (row) row.hidden = false;
    var fb = el.querySelector('[data-ag-delivery-fallback]'); if (fb) fb.hidden = true;
    var xmas = el.querySelector('[data-ag-delivery-xmas]');
    if (xmas) { var t = christmasLine(s.today, el.getAttribute('data-order-by')); xmas.textContent = t; xmas.hidden = !t; }
  }

  var api = { estimate: estimate, steps: steps, fmt: fmt, christmasLine: christmasLine, isBusinessDay: isBusinessDay, holidays: holidays, addBusinessDays: addBusinessDays };
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; return; }
  root.agDelivery = api;
  function init() {
    document.querySelectorAll('.ag-dsteps').forEach(function (el) { renderSteps(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})(typeof window !== "undefined" ? window : this);
